import React from 'react';

/**
 * Embeds the original Flask chat interface at /chat inside an iframe.
 */
const LegacyChatPage: React.FC = () => {
  const isDev = typeof window !== 'undefined' && window.location.port === '3000';
  const apiBase = isDev ? 'http://localhost:8000' : window.location.origin;
  const src = `${apiBase}/chat`;

  return (
    <div className="min-h-[70vh] bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Legacy Chat</h1>
        <p className="text-gray-600 mb-6">This is the original chat interface embedded from the Flask app.</p>
        <div className="border rounded-lg overflow-hidden h-[70vh]">
          <iframe title="Legacy Chat" src={src} className="w-full h-full border-0" />
        </div>
      </div>
    </div>
  );
};

export default LegacyChatPage;


